import { Preferences } from '@capacitor/preferences';
import { readLegacy, clearLegacy } from './localStorageLegacy';

/**
 * Generic persistence wrapper — the ONLY module that touches @capacitor/preferences.
 * ⚠️ Ne pas importer hors de storage/storageGate.ts : le code métier obtient l'API via
 * declareStorageDomain (déclaration du cycle de vie obligatoire).
 * Async API, works on web (localStorage-backed) and native.
 */

export async function getString(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    if (value !== null) return value;

    // Migration legacy : ancien localStorage brut → Preferences (puis purge). Temporaire.
    const legacy = readLegacy(key);
    if (legacy === null) return null;
    await Preferences.set({ key, value: legacy });
    clearLegacy(key);
    return legacy;
}

export async function setString(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
}

export async function getJSON<T>(key: string): Promise<T | null> {
    const raw = await getString(key);
    if (raw === null) return null;
    try {
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
}

export async function setJSON<T>(key: string, value: T): Promise<void> {
    await setString(key, JSON.stringify(value));
}

export async function remove(key: string): Promise<void> {
    await Preferences.remove({ key });
    clearLegacy(key); // purge un éventuel legacy jamais migré (no-op si absent)
}

export async function getKeys(): Promise<string[]> {
    const { keys } = await Preferences.keys();
    return keys;
}
